import styled from '@emotion/styled'

import colorNames from '../../design/color-names'

export const SidePanelContainer = styled.aside(({ top, width, show }) => ({
  //  label: 'side-panel-container',
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  background: '#ffffff',
  boxShadow: show ? '-1px 0px 10px rgba(37, 37, 37, 0.15)' : 'none',
  borderLeft: `1px solid ${colorNames.athensGray}`,
  right: 0,
  bottom: 0,
  top: `${top}`,
  width: `${width}`,
  transition: 'transform 0.25s ease-out',
  transform: show ? `translateX(0)` : `translateX(${width})`,
  zIndex: 900
}))

export const SidePanelSeparator = styled.hr`
  margin: 0;
  padding: 0;
  border: 0;
  border-top: 2px solid ${colorNames.athensGray};
`

export const SidePanelHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;

  ${({ padding }) => (padding !== undefined ? `padding: ${padding};` : '')}

  ${({ showBorder }) =>
    showBorder ? `border-bottom: 2px solid ${colorNames.athensGray}` : ''}
`

SidePanelHeaderContainer.defaultProps = {
  padding: '16px 32px'
}
